// src/pages/EducationPage.jsx
import React, { useEffect, useState } from "react";
import NavBar from "../components/NavBar";

const MatrixEducationBackground = () => {
  useEffect(() => {
    const canvas = document.getElementById("matrix-education-bg");
    const context = canvas.getContext("2d");

    let width = window.innerWidth,
        height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
    
    const katakana = "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン";
    const latin = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const nums = "0123456789";
    const alphabet = katakana + latin + nums;
    const fontSize = 16;
    const columns = width / fontSize;
    const rainDrops = new Array(Math.floor(columns)).fill(1);
    
    const draw = () => {
      context.fillStyle = "rgba(0,0,0,0.05)";
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#0F0";
      context.font = fontSize + "px monospace";
      for (let i = 0; i < rainDrops.length; i++) {
        const text = alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        context.fillText(text, i * fontSize, rainDrops[i] * fontSize);
        if (rainDrops[i] * fontSize > height && Math.random() > 0.975) {
          rainDrops[i] = 0;
        }
        rainDrops[i]++;
      }
    };
    
    const interval = setInterval(draw, 30);
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <canvas
      id="matrix-education-bg"
      className="fixed top-0 left-0 w-full h-full opacity-20 pointer-events-none"
    />
  );
};

const EducationPage = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);
  return (
    <section className="relative min-h-screen bg-gray-900 text-white overflow-hidden">
      <NavBar />
      <MatrixEducationBackground />
      <div className="relative z-10 container mx-auto px-4 py-16">
        {/* Header */}
        <header
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <h1 className="text-5xl font-bold font-mono text-green-500 mb-4">
            Education Solutions
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            AIOrbis revolutionizes the educational experience with innovative, interactive digital platforms that empower learners and educators alike.
          </p>
        </header>

        {/* Overview Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4 text-center">
            Overview
          </h2>
          <p className="text-gray-300">
            Our education technology solutions are built to facilitate engaging, personalized learning environments—combining advanced analytics, seamless integration, and creative design.
          </p>
        </section>

        {/* Key Features Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4 text-center">
            Key Features
          </h2>
          <ul className="list-disc ml-8 text-gray-300 space-y-2">
            <li>Interactive Digital Classrooms</li>
            <li>Personalized Learning Paths</li>
            <li>Real-Time Progress Tracking</li>
            <li>Secure Cloud-Based Infrastructure</li>
            <li>Seamless Integration with LMS</li>
          </ul>
        </section>

        {/* Call-to-Action */}
        <section className="text-center">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4">
            Transform Education with AIOrbis
          </h2>
          <p className="text-gray-300 mb-8">
            Discover how our solutions can enhance the learning experience and empower your educational institution.
          </p>
          <a
            href="/contact"
            className="px-8 py-3 bg-green-600 hover:bg-green-500 text-white font-mono rounded-lg transition-colors duration-300"
          >
            Contact Us
          </a>
        </section>
      </div>
    </section>
  );
};

export default EducationPage;
